// Module
var code = "<h2 id=\"mobile-app\">Mobile App</h2> <p>Make payments on the go from the palm of your hand.</p> ";
// Exports
export default code;